import { render, staticRenderFns } from "./TemplatesConfigurations.vue?vue&type=template&id=52baad8b&scoped=true"
import script from "./TemplatesConfigurations.vue?vue&type=script&lang=js"
export * from "./TemplatesConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52baad8b",
  null
  
)

export default component.exports